export default __webpack_public_path__ + "static/media/savings.5b786339.svg";